/* Digital Ummah — Muslim names directory (replaces the old random-only picker).
   Data: dxl-ummah-names.json (curated; BM + EN meanings, Arabic, category, short factual notes). */
(function () {
  "use strict";
  if (window.__dxn) return; window.__dxn = 1;

  function L() { return window.duLang === 1 ? 1 : 0; }
  function T(en, ms) { return L() ? ms : en; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function fold(s) { return String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ'’`\-\s]/g, ""); }

  var CATS = [
    ["", "All", "Semua"],
    ["nabi", "Prophets", "Nabi & Rasul"],
    ["sahabat", "Companions & figures", "Sahabat & tokoh"],
    ["abdul", "Abdul + Asma'ul Husna", "Abdul + Asmaul Husna"],
    ["quran", "From the Quran", "Daripada al-Quran"],
    ["sifat", "Virtues", "Sifat terpuji"],
    ["alam", "Nature & beauty", "Alam & keindahan"]
  ];
  var GEN = [["", "Any", "Semua"], ["m", "Boys", "Lelaki"], ["f", "Girls", "Perempuan"]];
  var PAGE = 24;

  var data = null, st = { q: "", g: "", c: "", shown: PAGE, open: -1, pick: -1 };

  function url() {
    if (window.DXN_DATA_URL) return window.DXN_DATA_URL;
    var s = document.querySelector("script[src*='dxl-ummah-names.js']");
    return s ? s.src.replace(/dxl-ummah-names\.js.*/, "dxl-ummah-names.json") : "";
  }
  function load() {
    if (data) return Promise.resolve(data);
    return fetch(url()).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (j) {
      data = (j.names || []).map(function (x, i) { x.i = i; x.k = fold(x.n) + " " + (x.a || []).map(fold).join(" "); return x; });
      return data;
    });
  }

  function match(x) {
    if (st.g && x.g !== st.g && x.g !== "u") return false;
    if (st.c && x.c !== st.c) return false;
    if (!st.q) return true;
    var q = fold(st.q);
    return x.k.indexOf(q) > -1 || fold(x.ms).indexOf(q) > -1 || fold(x.en).indexOf(q) > -1 || (x.ar && x.ar.replace(/[ً-ْٰ]/g, "").indexOf(st.q.replace(/[ً-ْٰ]/g, "")) > -1);
  }
  function gLabel(g) { return g === "m" ? T("Boy", "Lelaki") : g === "f" ? T("Girl", "Perempuan") : T("Boy or girl", "Lelaki atau perempuan"); }
  function cLabel(c) { for (var i = 0; i < CATS.length; i++) if (CATS[i][0] === c) return CATS[i][1 + L()]; return ""; }

  function feature(x) {
    if (!x) return "";
    var note = L() ? x.nm : x.ne;
    return '<div class="dxn-feat">' +
      (x.ar ? '<div class="nm" lang="ar" dir="rtl">' + esc(x.ar) + '</div>' : "") +
      '<div class="nn">' + esc(x.n) + '</div>' +
      '<div class="nmean">' + esc(L() ? x.ms : x.en) + '</div>' +
      '<div class="nmeta">' + esc(gLabel(x.g)) + ' · ' + esc(cLabel(x.c)) + '</div>' +
      (note ? '<div class="nnote">' + esc(note) + '</div>' : "") +
      '</div>';
  }

  function shell(box) {
    box.innerHTML =
      '<p class="dxn-lead"></p>' +
      '<div class="dxn-feat-wrap" aria-live="polite"></div>' +
      '<div class="dxn-again-row"><button type="button" class="du-locbtn dxn-again"></button></div>' +
      '<div class="dxn-tools">' +
        '<label class="dxn-find"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2"/><path d="M20 20l-3.5-3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '<input type="search" class="dxn-q" autocomplete="off" spellcheck="false"></label>' +
        '<div class="du-toggle dxn-gen" role="group"></div>' +
      '</div>' +
      '<div class="du-chips dxn-cats" role="group"></div>' +
      '<p class="dxn-count" aria-live="polite"></p>' +
      '<div class="dxn-grid"></div>' +
      '<div class="dxn-more-row"><button type="button" class="du-locbtn dxn-more"></button></div>' +
      '<p class="dxn-src"></p>';
  }

  function render() {
    var box = document.querySelector(".du-card.du-name"); if (!box || !data) return;
    if (!box.querySelector(".dxn-grid")) shell(box);
    box.classList.add("dxn");
    box.querySelector(".dxn-lead").textContent = T(
      "A good name is a gift to a child. The Prophet ﷺ said the names most beloved to Allah are Abdullah and Abdul Rahman (Muslim 2132). Search " + data.length + " names with their meanings.",
      "Nama yang baik ialah hadiah buat anak. Nabi ﷺ bersabda, nama yang paling disukai Allah ialah Abdullah dan Abdul Rahman (Muslim 2132). Cari " + data.length + " nama berserta maksudnya.");
    box.querySelector(".dxn-again").textContent = T("Another name", "Nama lain");
    var inp = box.querySelector(".dxn-q");
    inp.placeholder = T("Search a name or meaning, e.g. Aisyah, light", "Cari nama atau maksud, cth. Aisyah, cahaya");
    inp.setAttribute("aria-label", T("Search names", "Cari nama"));
    if (inp.value !== st.q) inp.value = st.q;
    box.querySelector(".dxn-gen").innerHTML = GEN.map(function (g) { return '<button type="button" data-g="' + g[0] + '" class="' + (st.g === g[0] ? "on" : "") + '" aria-pressed="' + (st.g === g[0]) + '">' + esc(g[1 + L()]) + '</button>'; }).join("");
    box.querySelector(".dxn-cats").innerHTML = CATS.map(function (c) { return '<button type="button" class="du-chip' + (st.c === c[0] ? " on" : "") + '" data-c="' + c[0] + '" aria-pressed="' + (st.c === c[0]) + '">' + esc(c[1 + L()]) + '</button>'; }).join("");

    var list = data.filter(match);
    if (st.pick < 0 || !match(data[st.pick])) st.pick = list.length ? list[Math.floor(Math.random() * list.length)].i : -1;
    box.querySelector(".dxn-feat-wrap").innerHTML = st.pick > -1 ? feature(data[st.pick]) : "";
    box.querySelector(".dxn-again-row").hidden = list.length < 2;

    box.querySelector(".dxn-count").textContent = list.length
      ? T(list.length + (list.length === 1 ? " name" : " names"), list.length + " nama")
      : T("No names match. Try another spelling.", "Tiada nama yang sepadan. Cuba ejaan lain.");
    var h = "";
    list.slice(0, st.shown).forEach(function (x) {
      var open = st.open === x.i, note = L() ? x.nm : x.ne;
      h += '<button type="button" class="dxn-it' + (open ? " open" : "") + '" data-i="' + x.i + '" aria-expanded="' + open + '">' +
        '<span class="dxn-top"><span class="dxn-n">' + esc(x.n) + '</span>' + (x.ar ? '<span class="dxn-ar" lang="ar" dir="rtl">' + esc(x.ar) + '</span>' : "") + '</span>' +
        '<span class="dxn-m">' + esc(L() ? x.ms : x.en) + '</span>' +
        '<span class="dxn-tags"><i class="dxn-g dxn-g-' + x.g + '">' + esc(gLabel(x.g)) + '</i><i>' + esc(cLabel(x.c)) + '</i></span>' +
        (open ? '<span class="dxn-x">' + (note ? '<span class="dxn-note">' + esc(note) + '</span>' : "") +
          (x.a && x.a.length ? '<span class="dxn-alt">' + esc(T("Other spellings: ", "Ejaan lain: ") + x.a.join(", ")) + '</span>' : "") + '</span>' : "") +
        '</button>';
    });
    box.querySelector(".dxn-grid").innerHTML = h;
    var more = box.querySelector(".dxn-more");
    box.querySelector(".dxn-more-row").hidden = list.length <= st.shown;
    more.textContent = T("Show more (" + (list.length - st.shown) + " left)", "Tunjuk lagi (" + (list.length - st.shown) + " lagi)");
    box.querySelector(".dxn-src").textContent = T(
      "Meanings are from classical Arabic usage. Where a popular name has no clear Arabic meaning, it says so. Hadith references follow sunnah.com numbering.",
      "Maksud nama berdasarkan penggunaan bahasa Arab klasik. Bagi nama popular yang tiada maksud Arab yang jelas, ia dinyatakan. Rujukan hadis mengikut penomboran sunnah.com.");
  }

  function boot() {
    var box = document.querySelector(".du-card.du-name"); if (!box) return;
    // keep the old inline handlers working
    window.duGetName = function () { st.pick = -1; render(); };
    window.duNameGender = function (g) { st.g = g === 1 ? "m" : g === 2 ? "f" : ""; st.shown = PAGE; st.pick = -1; render(); };
    load().then(render).catch(function () {
      box.querySelector("#duNameOut") && (box.querySelector("#duNameOut").innerHTML = '<div class="du-err">' + esc(T("Could not load names.", "Nama tidak dapat dimuatkan.")) + '</div>');
    });
    var t;
    box.addEventListener("input", function (e) {
      if (!e.target.classList.contains("dxn-q")) return;
      clearTimeout(t); var v = e.target.value;
      t = setTimeout(function () { st.q = v.trim(); st.shown = PAGE; st.open = -1; render(); }, 140);
    });
    box.addEventListener("click", function (e) {
      var b = e.target.closest("button"); if (!b || !box.contains(b)) return;
      if (b.hasAttribute("data-g")) { st.g = b.getAttribute("data-g"); st.shown = PAGE; st.pick = -1; render(); return; }
      if (b.hasAttribute("data-c")) { st.c = b.getAttribute("data-c"); st.shown = PAGE; st.open = -1; st.pick = -1; render(); return; }
      if (b.classList.contains("dxn-again")) {
        var list = data.filter(match); if (list.length > 1) { var p; do { p = list[Math.floor(Math.random() * list.length)].i; } while (p === st.pick); st.pick = p; }
        render(); return;
      }
      if (b.classList.contains("dxn-more")) { st.shown += PAGE * 2; render(); return; }
      if (b.classList.contains("dxn-it")) { var i = +b.getAttribute("data-i"); st.open = st.open === i ? -1 : i; render(); var nb = box.querySelector('.dxn-it[data-i="' + i + '"]'); if (nb) nb.focus({ preventScroll: true }); }
    });
    // re-render when the page language changes
    var o = window.duSetLang;
    if (typeof o === "function" && !o.__dxn) { window.duSetLang = function () { var r = o.apply(this, arguments); render(); return r; }; window.duSetLang.__dxn = 1; }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
